import * as React from 'react';
import { useSelector } from 'react-redux';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectOfferBookingEnabled } from 'shared/selectors/newbuildingBrokerOfferBooking';

import { getNewbuildingBrokerOnboardingCookie, setNewbuildingBrokerOnboardingCookie } from '../utils/onboarding';

export const useNewbuildingBrokerOnboarding = () => {
  const [open, setOpen] = React.useState(false);
  const closeOnboarding = React.useCallback(() => setOpen(false), []);

  const offerBookingEnabled = useSelector(selectOfferBookingEnabled);
  const { config } = useApplicationContext();

  React.useEffect(() => {
    const isOnboardingShown = getNewbuildingBrokerOnboardingCookie();

    if (offerBookingEnabled && !isOnboardingShown) {
      const onboardingDelay = config.get<number>('newbuildingBroker.onboarding.delay') ?? 2000;

      setTimeout(() => {
        setOpen(true);
        setNewbuildingBrokerOnboardingCookie();
      }, onboardingDelay);
    }
  }, [offerBookingEnabled, config]);

  return { open, closeOnboarding };
};
